import React from 'react'
import PropTypes from 'prop-types'
import { StyledTableRow } from 'shared/components/Table'
import { Stack, TableCell, Typography } from '@mui/material'

const TableEmptyResult = ({ list, colSpan = 6 }) => {
    if (list && list.length == 0) {
        return (
            <StyledTableRow sx={{ height: '300px', backgroundColor: 'white !important' }}>
                <TableCell colSpan={colSpan} align='center' sx={{ border: 'none !important' }}>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Typography>Tidak Ada Data</Typography>
                    </Stack>
                </TableCell>
            </StyledTableRow>
        )
    }

    return
}

TableEmptyResult.propTypes = {
    list: PropTypes.any,
    colSpan: PropTypes.number
}

export default TableEmptyResult